import * as Rx from 'rxjs'
import {IMessage, IMessageProvider, MessageType} from '../PA.Core.IF.Basic'
import * as _ from 'lodash'
import {AuditService} from "../Security/AuditService";
import {ExecutionSerializer} from "./ExecutionSerializer";



export class MessageProvider implements IMessageProvider
{
    Messages: IMessage[];
    MessagesChanged: Rx.BehaviorSubject<IMessageProvider>;

    private _loggerEnabled: boolean
    private _logger: AuditService
    private _loggerQueue: IMessage[]
    private _loggerWriter: ExecutionSerializer

    constructor(){
        this.Messages = [];
        this.MessagesChanged = new Rx.BehaviorSubject<IMessageProvider>(null);
        this._loggerEnabled = false
        this._logger = undefined
        this._loggerQueue = []
        this._loggerWriter = undefined
    }


    addMessage(aMsg: IMessage): void {
        if(aMsg && _.isEmpty(aMsg.time))
            aMsg.time = new Date()
        this.Messages.push(aMsg);
        this.MessagesChanged.next(this);

        if(this._loggerEnabled) {
            this._loggerQueue.push(aMsg)
            this._loggerWriter.Run()
        }

    }

    addMessages(arrMsg: IMessage[]) : void {

        _.forEach(arrMsg, (aMsg) => {
            if(aMsg && _.isEmpty(aMsg.time))
                aMsg.time = new Date()
        })

        this.Messages.push.apply(this.Messages, arrMsg);
        this.MessagesChanged.next(this);

        if(this._loggerEnabled) {
            this._loggerQueue.push.apply(this._loggerQueue, arrMsg);
            this._loggerWriter.Run()
        }
    }

    removeMessage(MessageCode: string): void {
        _.remove(this.Messages, function(element){
            if(_.isEmpty(element))
                return true;

            if(element.code == MessageCode)
                return true;

            return false;
        });

        this.MessagesChanged.next(this);
    }

    addTextMessages(MessageCodePrefix: string, aType: MessageType, pArrText: string[] | string){

        let msgs: IMessage[] = []
        let arrText = pArrText
        if(!_.isArray(arrText)){ arrText = [arrText]}

        _.forEach(arrText, (aText, idx) => {
            let aMsg: IMessage = {
                code: MessageCodePrefix + idx.toString(),
                title: aText,
                description: aText,
                count: 0,
                details: aText,
                subtitle: aText,
                type: aType,
                time: new Date()
            }
            msgs.push(aMsg)
        })

        this.addMessages(msgs)
    }

    clearMessages(): void {

        this.Messages = [];
        this.MessagesChanged.next(this);
    }

    countMessages(aMessageType:MessageType): number {
        if (!aMessageType)
            return this.Messages.length;
        var returnValue = 0;

        _.forEach(this.Messages, function(aMessage){
            if(aMessage.type == aMessageType)
                returnValue += 1;
        })

        return returnValue;
    }


    enableLogging(refTypeId: string, refWbId: number){
        this._loggerEnabled = true
        this._logger = new AuditService()
        this._logger.setReference(refTypeId, refWbId)
        if(!this._loggerWriter){
            this._loggerWriter = new ExecutionSerializer(this, this._writeMessages, [], 250)
        }

    }

    disableLogging(){
        this._loggerEnabled = false
    }

    private async _writeMessages(): Promise<void> {
        const self = this

        if(!self._loggerEnabled)
            return

        if(!self._loggerQueue.length)
            return

        _.forEach(self._loggerQueue, (msg) => {
            self._logger.LogMsgSync(msg)
        })
        self._loggerQueue = []
        await self._logger.Save()

    }

}


